export * from './product-details/product-details.component';
export * from './product-search/product-search.component';
